import { Link } from 'react-router-dom';

const encyclopediaCards = [
  {
    icon: 'ri-book-open-line',
    title: 'Что такое корпоративное обучение',
    description: 'Полное руководство по организации корпоративного обучения: виды, форматы, методы и оценка эффективности.',
    to: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Обучение персонала',
    description: 'Системный подход к обучению сотрудников: от диагностики потребностей до измерения результатов.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Обучение отдела продаж',
    description: 'Тренинги и методики для роста конверсии, повышения среднего чека и построения долгосрочных отношений с клиентами.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Тренинг для руководителей',
    description: 'Развитие управленческих компетенций: лидерство, принятие решений, мотивация команды и стратегическое мышление.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: 'Развитие Soft Skills',
    description: 'Эмоциональный интеллект, коммуникации, тайм-менеджмент и адаптивность — ключевые гибкие навыки для современных команд.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
  },
  {
    icon: 'ri-building-line',
    title: 'Корпоративная академия',
    description: 'Создание внутреннего учебного центра компании: структура, программы, оценка и развитие талантов.',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
  },
];

export default function StudyEncyclopediaSection() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-book-read-line"></i>
            База знаний
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Изучите корпоративное обучение
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Всё, что нужно знать о корпоративном обучении: от базовых понятий до построения корпоративной академии. Выберите тему и погрузитесь в неё.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {encyclopediaCards.map((card, index) => (
            <Link
              key={index}
              to={card.to}
              className="group bg-white rounded-xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${card.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                {card.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-1">
                {card.description}
              </p>
              <span className="inline-flex items-center text-teal-600 font-semibold text-sm group-hover:gap-2 transition-all gap-1 whitespace-nowrap">
                Подробнее <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie"
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Перейти в энциклопедию <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}